import { SBack, SGeneralForms, STitle } from 'shj-components'
import { Upload, Space, Button, Spin, message } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getDetailByProcInstId } from '@/services/order'
import { getUser } from 'shj-utils'
import { isNilOrNull } from '@/utils'
import ProcessModal from '@/components/ProcessModal'
import FlowTransfer from '@/components/TransferModal'
import ProcessRecord from '@/components/ProcessRecord'
import ProjectDetail from './components/ProjectDetail'
import styles from './index.module.less'

const baseInfoConfig: any = [
  {
    // title: '基础信息',
    formItem: [
      {
        name: 'orderNo',
        label: '订单号',
        spanCol: 6,
      },
      {
        name: 'goodsName',
        label: '商品名称',
        spanCol: 6,
      },
      {
        name: 'bizTagName',
        label: '需求标签',
        spanCol: 6,
      },
      {
        name: 'serviceAddress',
        label: '服务地址',
        spanCol: 6,
      },
      {
        name: 'customerName',
        label: '客户名称',
        spanCol: 6,
      },
      {
        name: 'customerPhone',
        label: '客户电话',
        spanCol: 6,
      },
      {
        name: 'orderAmount',
        label: '订单金额',
        spanCol: 6,
      },
      {
        name: 'orderCreateName',
        label: '订单创建人',
        spanCol: 6,
      },
    ],
  },
]

const quoteInfoConfig: any = [{
  formItem: [
    {
      name: 'quoteTypeStr',
      label: '报价类型',
      spanCol: 6,
    },
    {
      name: 'quoteArea',
      label: '报价面积',
      spanCol: 6,
    },
    {
      name: 'totalAmount',
      label: '报价金额',
      spanCol: 6,
    },
    {
      name: 'reviewCount',
      label: '审批次数',
      spanCol: 6,
    },
  ],
}]

const originBtnList = [{
  name: '订单详情',
  key: 'orderDetail',
  click: (data) => window.open(`/order/list/details/${data?.variables?.entity?.orderId}`)
}, {
  name: '审核记录',
  key: 'processRecord'
}]

export default function ImageProcessDetail() {
  const navaigate = useNavigate()
  const { id } = useParams() // 流程id
  const user = getUser()
  const basicRef = useRef<any>()
  const quoteRef = useRef<any>()
  const drawRef = useRef<any>()
  const [flowData, setFlowData] = useState<any>(null) // 商品详情信息
  const [entityData, setEntityData] = useState<any>({}) // 商品详情信息
  const [drawerList, setDrawerList] = useState<any>([]) //
  const [openProcessModal, setOpenProcessModal] = useState<any>(false)
  const [btnList, setBtnList] = useState<any>([])
  const [transterOpen, setTransterOpen]: any = useState(false)
  const [spinLoading, setSpinLoading] = useState<any>(false)
  const [openProcessRecordModal, setOpenProcessRecordModal] = useState(false);

  // 页面初始化
  useEffect(() => {
    initPage()
  }, [])

  const drawListConfig: any = [{
    formItem: [
      {
        label: '图纸源文件',
        spanCol: 24,
        name: 'srcFileUrl',
        children: (
          <>
            <div>
              <Upload fileList={drawerList} showUploadList={{showRemoveIcon: false}}></Upload>
            </div>
          </>
        ),
      },
    ],
  }]

  const getToolTip = item => {
    const { key, name, click = () => ({}), disabled, type } = item
    if (item.render) {
      return item.render
    }
    return (
      <Button
        key={key}
        disabled={disabled}
        onClick={e => {
          key === 'processRecord' ? setOpenProcessRecordModal(true) : click(flowData)
        }} 
        type={type}
      >
        {name}
      </Button>
    )
  }

  const initPage = async () => {
    try {
      setSpinLoading(true);

      const res: any = await getDetailByProcInstId({
        params: {
          procInstId: id,
        }
      })
      if (res?.variables?.entity) {
        setFlowData(res)
        setEntityData(res?.variables?.entity)

        const list = res?.variables?.entity?.srcFileUrl?.map(item => ({
          name: item.split('/')?.[item.split('/')?.length - 1],
          url: item
        }))
        setDrawerList(list || [])

        const nodeInfo = res?.currentAuditList?.[0];
        const btns: any = [];
        if (!(nodeInfo?.nodeId === 'Activity_1dt25d3' && flowData?.variables?.creator === user?.userId)) {

          if (!res.isEnd) {
            btns.push({
              name: '转办',
              key: 'transfer',
              click: () => setTransterOpen(true)
            })
          }

          if (!res?.isEnd && res?.isAudit) {
            btns.push({
              name: '审核',
              key: 'process',
              type: 'primary',
              click: () => setOpenProcessModal(true)
            })
          }
        }
        setBtnList([
          ...originBtnList,
          ...btns,
        ])
      }
      setSpinLoading(false)
    } catch (err) {
      setSpinLoading(false)
      console.log(err)
    }
  }

  const onClose = (msg?: string) => {
    setTransterOpen(false)
    if (!isNilOrNull(msg)) {
      message.success(msg ?? '转办成功')
      initPage();
    }
  }

  const goBack = () => {
    navaigate('/order/processList')
  }

  return (
    <SBack
      title={'图审详情'}
      level={2}
      extra={[<Space style={{flexWrap: 'wrap'}} className={styles.btns}>{btnList.map(btn => getToolTip(btn))}</Space>]}
      goPath={goBack}
    >
      <Spin spinning={spinLoading}>
        <div className={styles.baseBox}>
          <div style={{ padding: '20px 15px 0px' }}>
            <STitle title={'基本信息'} />
            <SGeneralForms
              isDetail={true}
              configs={baseInfoConfig}
              detailsData={entityData}
              ref={basicRef}
              formConfig={{ style: {} }}
            />
          </div>
          <div style={{ padding: '0px 15px 0px' }}>
            <STitle title={'报价信息'} />
            <SGeneralForms
              isDetail={true}
              configs={quoteInfoConfig}
              detailsData={entityData}
              ref={quoteRef}
              formConfig={{ style: {} }}
            />
          </div>
          <div style={{ padding: '0px 15px 0px' }}>
            <STitle title={'图纸信息'} />
            <SGeneralForms
              isDetail={true}
              configs={drawListConfig}
              detailsData={entityData}
              ref={drawRef}
              formConfig={{ style: {} }}
            />
          </div>
          <div style={{ padding: '0px 15px 0px' }}>
            <STitle title={'方案详情'} />
            <ProjectDetail flowData={flowData} />
          </div>
        </div>
      </Spin>
      {
        openProcessModal ? <ProcessModal
          title='方案审核'
          open={openProcessModal} 
          setOpen={setOpenProcessModal}
          flowData={flowData}
          reload={initPage}
        /> : null
      }
      {
        openProcessRecordModal ? <ProcessRecord
          title='审核记录'
          open={openProcessRecordModal}
          setOpen={setOpenProcessRecordModal}
          quoteBudgetId={flowData?.variables?.quoteBudgetId}
        /> : null
      }
      <FlowTransfer taskId={flowData?.currentAuditList?.[0]?.taskId} open={transterOpen} onClose={onClose} />
    </SBack>
  )
}
